(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click', event => {
  document.querySelectorAll('#MainNav .nav-dropdown[open]').forEach(dropdown => {
    if (!dropdown.contains(event.target)) dropdown.open = false;
  });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const openDropdown = document.querySelector('#MainNav .nav-dropdown[open]');
  if (openDropdown) {
    event.preventDefault();
    event.stopImmediatePropagation();
    openDropdown.open = false;
    openDropdown.querySelector('summary').focus();
  }
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bb-hero-carousel')) {
  customElements.define('bb-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bb-hero-track');
      this.slides = [...this.querySelectorAll('.bb-hero-slide')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.active = 0;
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.querySelector('.bb-hero-controls').hidden = this.slides.length < 2;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.dataset.slide !== undefined) this.go(Number(button.dataset.slide));
        if (button.dataset.step) this.go(this.active + Number(button.dataset.step));
      }, opts);
      this.track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.go(this.active + (event.key === 'ArrowRight' ? 1 : -1));
      }, opts);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const left = this.track.getBoundingClientRect().left;
          let nearest = 0;
          this.slides.forEach((slide, i) => {
            if (Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(this.slides[nearest].getBoundingClientRect().left - left)) nearest = i;
          });
          this.active = nearest;
          this.dots.forEach((dot, i) => i === nearest ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
        });
      }, { ...opts, passive: true });
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index >= 0) this.go(index);
      }, opts);
    }
    go(index) {
      const next = (index + this.slides.length) % this.slides.length;
      const offset = this.slides[next].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollBy({ left: offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      this.active = next;
    }
    disconnectedCallback() {
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-departments"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bb-brand-edit')) {
  customElements.define('bb-brand-edit', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('.bb-edit-panel')];
      this.current = 0;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelector('.bb-edit-tabs').hidden = false;
      this.querySelector('.bb-edit-bottom').hidden = false;
      this.panels.forEach((panel, i) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', this.tabs[i].id);
      });
      this.show(0);
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.show(i), options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % 2;
          if (event.key === 'ArrowLeft') next = (i + 1) % 2;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = 1;
          if (next === undefined) return;
          event.preventDefault();
          this.show(next);
          this.tabs[next].focus();
        }, options);
      });
      this.querySelectorAll('[data-edit-step]').forEach(button => button.addEventListener('click', () => this.show((this.current + Number(button.dataset.editStep) + 2) % 2), options));
    }
    show(index) {
      this.current = index;
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
